module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Import-2ebdc81c0ea00f03641486fc9474f8efc5cd992d6329b291f6b617a8a78324ba.svg";